import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  CircularProgress,
} from '@mui/material';

interface InviteDialogProps {
  open: boolean;
  loading: boolean;
  error: string | null;
  onClose: () => void;
  onInvite: (email: string) => Promise<string | null>;
}

export function InviteDialog({ open, loading, error, onClose, onInvite }: InviteDialogProps) {
  const [email, setEmail] = useState('');

  const handleClose = () => {
    setEmail('');
    onClose();
  };

  const handleSubmit = async () => {
    const result = await onInvite(email.trim());
    if (!result) {
      setEmail('');
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Запросити учасника</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField
          autoFocus
          fullWidth
          label="Email адреса"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && !loading && handleSubmit()}
          disabled={loading}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>Скасувати</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading || !email.trim()}
          startIcon={loading ? <CircularProgress size={16} /> : undefined}
        >
          Запросити
        </Button>
      </DialogActions>
    </Dialog>
  );
}
